import { useState } from 'react';
import { Link } from 'react-router-dom';

import { validateEmail, notify } from '../utils/helpers';

import { 
	IconMap2, IconMail, IconPhone, IconHeartFilled, 
	IconBrandFacebook, IconShoppingCart, IconBrandInstagram, IconBrandYoutube 
} from '@tabler/icons-react';

const Subscribe = () => {

	const [subscribeEmail, setSubscribeEmail] = useState('');
	const [subscribeLoading, setSubscribeLoading] = useState(false);
	const [subscribeHappened, setSubscribeHappened] = useState(false);

	const handleSubscribe = async () => {

		if (!validateEmail(subscribeEmail)) {
			notify('Alege o adresa de mail valida.', 'warning');
			return;
		}

		try {
			setSubscribeLoading(true);

			const res = await fetch(process.env.REACT_APP_API_URL, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify({ type: "subscribe", email: subscribeEmail })
			});

			const data = await res.json();
			if (res.status === 200) {
				setSubscribeEmail('');
				setSubscribeHappened(true);
			}
			notify(data.message, data.type);
		} catch (err) {
			notify('Ceva nu a mers bine...', 'error');
		} finally {
			setSubscribeLoading(false);
		}
	};

	return (
		<>
			<h4>Oferte Speciale</h4>
			<p>Aboneaza-te si primesti reduceri exclusive.</p>

			<div className="subscription-container">
				<input
					type="email"
					className="form-control w-100"
					placeholder={subscribeHappened ? 'Multumim pentru abonare!' : 'Adresa Mail'}
					value={subscribeEmail}
					onChange={(e) => setSubscribeEmail(e.target.value)}
					required
					disabled={subscribeHappened}
				/>
				<button className="btn effect" onClick={handleSubscribe} disabled={subscribeLoading || subscribeHappened}>
					{subscribeLoading ? 'Se trimite...' : 'Aboneaza-te'}
				</button>
			</div>
		</>
	);
};

const Footer = () => {
	return (
		<div className="container-fluid footer pt-5 mt-5" id="contact">
			<div className="container py-5">
				<div className="row g-5">

					<div className="col-lg-3 col-md-6">
						<h4>Adresa</h4>
						<p>
							<IconMap2 className="me-2" stroke={1.4} size={24} />
							Str. Schitului 14, 127187, Buda-Cracunesti, Buzau, Romania
						</p>
						<p>
							<IconPhone className="me-2" stroke={1.4} size={24} />
							+40 723 531 203
						</p>
						<p>
							<IconMail className="me-2" stroke={1.4} size={24} />
							misupiese@gmail.com
						</p>
						
						<div className="social-media">
							<div>
								<a href="https://www.youtube.com/" aria-label="Visit YouTube">
									<IconBrandYoutube stroke={1.4} size={20} />
								</a>
							</div>
							<div>
								<a href="https://www.instagram.com/" aria-label="Visit Instagram">
									<IconBrandInstagram stroke={1.4} size={21} />
								</a>
							</div>
							<div>
								<a href="https://www.facebook.com/p/MISU-LZR-Mobauto-61552707839982/" aria-label="Visit Facebook">
									<IconBrandFacebook stroke={1.4} size={20} />
								</a>
							</div>
							<div>
								<a href="https://www.emag.ro/misulxoa/180994/v?ref=see_vendor_page" aria-label="Visit eMag">
									<IconShoppingCart stroke={1.3} size={19} />
								</a>
							</div>
						</div>
					</div>
		
					<div className="col-lg-2 col-md-6">
						<h4>Program de lucru</h4>
						<h6>Luni - Vineri:</h6>
						<p>07:00 - 18:00</p>
		
						<h6 className="mt-4">Sambata:</h6>
						<p>08:00 - 13:00</p>
					</div>

					<div className="col-lg-2 col-md-6">
						<h4>Informatii</h4>
						<p>
							<Link to="/privacy-policy" style={{ color: '#fff', textDecoration: 'underline' }}>
								Politica de Confidentialitate
							</Link>
						</p>
					</div>

					<div className="col-lg-5 col-md-12 d-flex flex-column align-items-center text-center">
						<Subscribe/>
					</div>
				</div>
			</div>
		
			<div className="container">
				<div className="copyright">
					<div className="row">
						<div className="col-md-6 text-center text-md-start mb-3 mb-md-0">
							&copy; <Link className="border-bottom" to="/">MISU LZR MOBAUTO S.R.L.</Link>
							<br />
						</div>
						<div className="col-md-6 text-center text-md-end">
							Made with <IconHeartFilled size={20} style={{ color: 'red' }}/> by{' '}
							<a className="border-bottom" href="https://trusthost.ro">
								TRUSTSOFT IT SOLUTIONS S.R.L.
							</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Footer